import {createReducer, Reducer} from "redux-act";
import {IPrizesPopup} from "modules/types";
import {fetchPrizesPopupSuccess, fetchPrizesPopup, fetchPrizesPopupFailed} from "modules/actions/jsons";

interface IPrizePopupStore {
	loading: boolean;
	data: IPrizesPopup[];
}

const initialState: IPrizePopupStore = {
	loading: false,
	data: [],
};

export const prize_popup: Reducer<IPrizePopupStore> = createReducer({}, initialState);

prize_popup.on(fetchPrizesPopup, (state, payload) => ({
	...state,
	loading: true,
}));

prize_popup.on(fetchPrizesPopupSuccess, (state, payload) => ({
	...state,
	loading: false,
	data: payload,
}));

prize_popup.on(fetchPrizesPopupFailed, (state) => ({
	...state,
	loading: false,
}));
